var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.logouted)?_c('Login',{on:{"login":_vm.login}}):_vm._e(),(_vm.logined)?_c('Layout',{on:{"logout":_vm.logout}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }